const initContact = () => {
    let attempts = 0;

    if (!document.querySelector('.c-contact-form')) {
        return;
    }

    const contactFormInterval = setInterval(() => {
        attempts++;

        // Get the iframe document
        const iframe = document.querySelector('iframe.hs-form-iframe');
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

        // Grab the styles from the <style> tag with the ID 'custom-styles' in the parent document
        const styleTag = document.getElementById('hs-smk-form-styles');
        const styles = styleTag.innerHTML;

        // Create a new <style> element inside the iframe
        const newStyleTag = iframeDocument.createElement('style');
        newStyleTag.innerHTML = styles;

        // Append the new <style> element to the iframe's <head>
        iframeDocument.head.appendChild(newStyleTag);

        if (attempts >= 4) {
            clearInterval(contactFormInterval)
            document.querySelector('.c-contact-form__wrapper').style.opacity = 1;
        }
    }, 100)
}
export {initContact}
